// removed by extract-text-webpack-plugin
module.exports = {"black":"#000000","controls":"_3lmeKkZgw6G5citkRuchGB","copyClipboard":"_39ODm7l_Hpu7CoK4dZKC3l"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShowCase/Controls/Controls.css
// module id = 866
// module chunks = 0